export default __webpack_public_path__ + "static/construction-631770d89ab461d12b9df3f398eaa4ed.png";